import { render, staticRenderFns } from "./SentimentFilter.vue?vue&type=template&id=723f4685"
import script from "./SentimentFilter.vue?vue&type=script&lang=js"
export * from "./SentimentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports